import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { get, ref } from 'firebase/database';
import { database } from '../firebase';
import { useAuth } from '../contexts/AuthContext';
import TrialStartButton from './Trial/TrialStartButton';
import PricingCatalog from './Pricing/PricingCatalog';
import usePricingCheckout from './Pricing/usePricingCheckout';

export default function SelectPlan() {
  const { t } = useTranslation('pricing');
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [showTrialOption, setShowTrialOption] = useState(false);
  const checkout = usePricingCheckout({ successUrl: `${window.location.origin}/`, cancelUrl: `${window.location.origin}/select-plan` });
  useEffect(() => { document.title = t('titles.selectPlan'); }, [t]);
  useEffect(() => {
    let active = true;
    setShowTrialOption(false);
    const checkPurchaseHistory = async () => {
      if (!currentUser) return;
      try {
        const collaborator = await get(ref(database, `collaborators/${currentUser.uid}`));
        const data = collaborator.exists() ? collaborator.val() : null;
        const companyId = data?.companyId || data?.company_uid || currentUser.uid;
        const subscription = await get(ref(database, `companies/${companyId}/subscription`));
        if (active) setShowTrialOption(!subscription.exists());
      } catch {
        // Eligibility remains enforced by startFreeTrial; don't advertise a trial on a failed read.
      }
    };
    checkPurchaseHistory();
    return () => { active = false; };
  }, [currentUser]);
  return <main className="jsq-pricing-page"><PricingCatalog onSelectPlan={checkout.selectPlan} pendingPlan={checkout.pendingPlan} error={checkout.error}
    footer={showTrialOption ? <><span>{t('cta.notReady')}</span><TrialStartButton onSuccess={() => navigate('/')} className="trial-featured-button" /></> : null} />
  </main>;
}
